import * as eventsType from '../types/events';

export const events = (state = {}, action) => {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case eventsType.CLEAR_EVENTS:
      return {};
    case eventsType.REPLACE_EVENTS:
      newState[action.scheduleScope] = [...action.events];
      return newState;
    case eventsType.UPDATE_EVENTS: // this case is not used
      if (!newState[action.scheduleScope]) {
        newState[action.scheduleScope] = [];
      }
      action.events.forEach((eventA) => {
        let eventIndex = -1;
        newState[action.scheduleScope].forEach((eventB, indexB) => {
          if (eventA.gameId !== 'unassigned') {
            if (eventA.gameId === eventB.gameId) {
              eventIndex = indexB;
            }
          } else {
            if (eventA._id === eventB._id) {
              eventIndex = indexB;
            }
          }

        });
        if (eventIndex !== -1) {
          newState[action.scheduleScope][eventIndex] = eventA;
        } else {
          newState[action.scheduleScope].push(eventA);
        }
      });
      return newState;
    default:
      return state;
  }
};
